import { Blockquote, Inset, Link, Text } from "@radix-ui/themes";


export default function Y2026M03D27() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>
          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2026-03-27.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                Punta Walichu Archeological Site, Argentina
              </Text>
            </Inset>
          </div>
          
          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                    27-29 March 2026, Labyrinth, Zagarolo (Rome-Italy)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Workshop: <i>Tradition and Spirituality: The Question of Agency</i>
                  </Blockquote>
                  <Blockquote size="2" color>
                     <b>Project Animism in Practice</b>
                  </Blockquote>
                  <Blockquote size="2" color>
                    Center Interstices in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    The workshop intends to explore the intricacies of “non-human agency” in traditional societies and its repercussion in the Western appropriation of certain techniques to gain access to it. Emphasis will be laid on the dynamics of “appropriation”, “invention”, “recontextualization”, and “hybridation”, as well as the ways in which certain modern approaches (like Analytical Psychology, Ethnopsychiatry, and certain forms of art) can intuitively summon foreign cultural entities to the point of rendering their own autopoiesis perceptible, especially ritual techniques.
                  </Text>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  )
}
